import { createFileRoute } from '@tanstack/react-router'
import { CustomerDetailPage } from '../../../../features/customers/customer-detail-page'
import { customerProfileSearchSchema } from '../../../../features/customers/search'

export const Route = createFileRoute('/_app/customers/$customerId/')({
  validateSearch: customerProfileSearchSchema,
  component: CustomerDetailPage,
})
